import React from "react";
import DashboardSidebar from "../DashboardSidebar";
import DashboardHeader from "../DashboardHeader";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useLocation } from "react-use";

const DashboardLayout = () => {
  const { user } = useAuth();
  const location = useLocation()
  if (!user?.access_token) {
    return <Navigate to="/login" />;
  }

  const {pathname = ""} = location;

  // let isSapActive = pathname == "/sap-reports" // for removing store dropdown from header
  let isSapActive = false
  let isVoucherDownload = pathname == "/voucher-reports"
  return (
    <div className="dashboard-layout-container">
      <DashboardSidebar />
      <div className="layout-container">
        <DashboardHeader isSapActive={isSapActive} isVoucherDownload={isVoucherDownload} />
        <div className="content-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
